import {
  createListenerMiddleware,
  type TypedStartListening,
} from '@reduxjs/toolkit';

import type { AppDispatch, RootState } from 'features/app/store/store';
import {
  getHearingById,
  getNotDisconnectedHearingByPhoneNumberSelector,
  setHearingStatusWithId,
} from 'features/call/call-hearing/store';
import { HearingParticipantType } from 'features/call/call-hearing/interfaces';
import { sendPendingSpawnedCallData } from 'features/spawn-call/store';

const listenerMiddleware = createListenerMiddleware();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;
const startListening = listenerMiddleware.startListening as AppStartListening;

startListening({
  actionCreator: setHearingStatusWithId,
  effect: (action, listenerApi) => {
    if (action.payload.status !== 'connecting') {
      return;
    }

    const state = listenerApi.getState();
    const hearing =
      (action.payload.id && getHearingById(state, action.payload.id)) ||
      getNotDisconnectedHearingByPhoneNumberSelector(
        state,
        action.payload.phoneNumber
      );

    if (
      hearing?.status !== 'connecting' ||
      hearing.type !== HearingParticipantType.PRIMARY
    ) {
      return;
    }

    listenerApi.dispatch(sendPendingSpawnedCallData());
  },
});

export const spawnedCallRecordMiddleware = listenerMiddleware.middleware;
